import { render, staticRenderFns } from "./proprietorNotificationEdit.vue?vue&type=template&id=2eb5df2e&"
import script from "./proprietorNotificationEdit.vue?vue&type=script&lang=js&"
export * from "./proprietorNotificationEdit.vue?vue&type=script&lang=js&"
import style0 from "./proprietorNotificationEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports